import { AvatarProfile } from "components/AvatarProfile";
import { EmailForm } from "components/programmatic/EmailForm";
import { HumanloopLogo } from "components/library/Logos";

export const Footer = () => {
  return (
    <div className="relative mt-[64px]">
      <div
        className="pointer-events-none absolute inset-0 flex flex-col"
        aria-hidden="true"
      >
        <div className="h-140 flex-none" />
        <div className="right-0 top-0 bottom-0 -z-10 h-full w-full min-w-[2500] bg-blue-800 bg-bottom bg-no-repeat ">
          {/* Second layer so we can reduce the opacity ontop of blue */}
          <div
            className="right-0 top-0 bottom-0 -z-10 h-full w-full min-w-[2500] bg-blue-800 bg-bottom bg-no-repeat opacity-40 "
            style={{
              backgroundImage: `url("/assets/tag-silhouette.png")`,
            }}
          ></div>
        </div>
      </div>
      {/* Letter */}
      <div className="container-lg">
        <div
          className=" rounded-[4px] border border-gray-400 bg-white  py-32 px-24 sm:p-80"
          style={{
            boxShadow:
              "0px 4px 24px rgba(0, 0, 0, 0.03), 0px 5px 8px rgba(0, 0, 0, 0.03)",
          }}
        >
          <div className="grid gap-x-60 text-18-28 text-gray-700 lg:grid-cols-2">
            <div className=" ">
              <h3 className="mb-32 font-display text-24-32 text-black md:text-32-40">
                <span className="rounded bg-blue-200 px-4 text-blue-500">
                  Free
                </span>
                {", "}
                customisable and extensible by design
              </h3>

              <p className="mt-24 text-16-24 md:text-18-28">
                As data scientists and engineers ourselves, we know that you
                need flexibility and control. So we’ve designed Programmatic to
                be <span className="font-bold">easily extensible</span> and to
                play nicely with the your{" "}
                <span className="font-bold">existing workflows</span> and data
                science tools.
              </p>
              <p className="mt-24 text-16-24 md:text-18-28">
                You can export your data in formats compatible with all major
                NLP libraries, write custom metrics, and have full control over
                tokenization and pre-processing.
              </p>
            </div>
            <div>
              <p className="mt-24 text-16-24 md:text-18-28 lg:pt-80 ">
                We’ve also chosen to make Programmatic{" "}
                <span className="font-bold">free</span> so nothing stops
                individual data scientists from getting the benefit of this
                powerful tool.
              </p>

              <p className="mt-24 text-16-24 md:text-18-28">
                The{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://humanloop.com"
                  className="text-blue-600 no-underline hover:underline"
                >
                  Humanloop Platform
                </a>{" "}
                closes the loop on training your NLP models. You can annotate
                ground truths, improve your models, and{" "}
                <span className="font-bold">instantly deploy custom NLP</span>.
                We believe it is the next best step for your dataset and we hope
                this inspires you to use it.
              </p>
              <div className="mt-24">
                <AvatarProfile
                  name={"Raza Habib"}
                  image={"/assets/marketing/people/raza.jpg"}
                  company={"CEO Humanloop"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg mt-140 flex flex-col gap-12 text-center text-white">
        <h2 className="text-24-32 opacity-70 md:text-32-32">
          Bigger, cleaner datasets await
        </h2>
        <h2 className="mb-40 text-24-32 text-white md:text-32-32">
          Get started now
        </h2>
        <div className="mx-auto mb-[92px] flex max-w-md justify-center gap-12 md:max-w-lg">
          <EmailForm shade={"black"} />
        </div>
      </div>

      <div className="flex items-center justify-center gap-16 border-t border-blue-100/20 bg-blue-800 py-32 text-center text-white">
        Powered by{" "}
        <a
          href="https://humanloop.com"
          title="Humanloop - all in one platform for NLP"
        >
          <HumanloopLogo className="h-24 w-[106px]" />
        </a>
      </div>
    </div>
  );
};
